import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.CHANGE_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.CHANGE_PHONE_NUMBER_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.CHANGE_PHONE_NUMBER_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_ACCOUNT_CHANGE_DATA:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
}
